const zxcvbn = require('zxcvbn');
export default {
  required (name) {
    return v => !!v || `${name} is required`
  },
  password: v => (v && v.length >= 8) || 'The password must have at least 8 characters',
  confirm_password: (v, password) => {
    return (v && v === password) || 'The password does not match'
  },
  email () {
    return v => /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
  },
  email_not_required (text) {
    return v => text ? /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid' : true 
  },
  number (name) {
    return v => isFinite(v) || `${name} has to be a number`
  },
  different_password: (v, old_password) => {
    return (v && v !== old_password) || 'The new password must be different from the old one'
  },
  check_simple_password: (v) => {
    if (v === null || v === undefined) {
      v = '';
  }
    const ret = zxcvbn(v);
    let result;

    if (ret.score >= 3) {
        result = ret.score;
    } else if (ret.feedback && ret.feedback.warning) {
        result = ret.feedback.warning;
    } else if (ret.feedback && ret.feedback.suggestions && ret.feedback.suggestions[0]) {
        result = true;
    } else {
        result = ret.feedback.suggestions[0];
    }

    return result;
  },
  password_strong: (value) => {
    var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=[\]{};:'",.<>?/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=[\]{};:'",.<>?/\\|`~]{8,}$/;
    //NOTE:la regularExpression (utilizzata negli altri software) è stata commentata perchè in questo applicativo 
    // è presente "eslint": "^6.7.2" che genera un errore relativamente agli escape,l'espressione di sopra 
    // è stata modificata per evitare l'errore
    //var regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~])[A-Za-z\d!£@#$%^&*()_\-+=\[\]{};:'",.<>?\/\\|`~]{8,}$/;


    if (!regularExpression.test(value)) {
            return "The password must have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    }
    return true;
},
  username: [
    v => !!v || 'Username or Email is required',
  ],
  account: {
    email: [
      v => !!v || 'Email is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    password: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 8) || 'The password must have at least 8 characters'
    ],
    name: [
      v => !!v || 'Name is required'
    ],
    surname: [
      v => !!v || 'Surname is required'
    ],
    role: [
      v => !!v || 'Role is required'
    ],
    phone: [
      v => !!v || 'Phone is required'
    ],
    status: [
      v => !!v || 'Status is required'
    ],
    privacy: [
      v => !!v || 'Privacy agree is required'
    ],
    site_id: [
      v => !!v || 'Site is required'
    ],
    city: [
      v => !!v || 'City is required'
    ],
    lab_id: [
      v => !!v || 'Lab is required'
    ],
  },
  protocol: [],
  roles: {
    group: [
      v => !!v || 'Group is required'
    ],
    name: [
      v => !!v || 'Name is required'
    ],
    description: [
      v => !!v || 'Desription is required'
    ],
    redcap_map: [
      v => !!v || 'Redcap map is required'
    ],
    safety_map: [
      v => !!v || 'Safety map is required'
    ],
    ecds_map: [
      v => !!v || 'Ecds map is required'
    ],
  },
  shipment: {
    pickupPoint : [
      v => !!v || 'Pickup Point is required'
    ],
    deliveryPoint : [
      v => !!v || 'Delivery Point is required'
    ],
    protocol : [
      v => !!v || 'Protocol is required'
    ],
    carrier : [
      v => !!v || 'Carrier is required'
    ],
    pickup_date : [
      v => !!v || 'Pickup date is required'
    ],
    delivery_within:[
      v=> !!v || 'Delivery Within is required'
    ],
    pickup_date_not_admin:[
      v => !!v || 'Pickup date is required',
      v=> v >= new Date().toISOString().split('T')[0] || 'Pickup date must be after today',
      v => {
        const day = new Date(v).getDay();
        const notAllowed = [0, 4, 5, 6]; // Domenica, Giovedì, Venerdì, Sabato
        return !notAllowed.includes(day) || 'Pickup date can be only on Monday, Tuesday and Wednesday';
      }
    ],
    to_attention_of : [
      v => !!v || 'To Attention Of is required'
    ],

  }
}
